import type { SupportedAppStatuses } from '@wix/app-market-services-types';
import { AppPageLink } from '../types';

export function isCompanyNameClickable({
  disabledLinks,
  status,
}: {
  disabledLinks: string[];
  status: SupportedAppStatuses;
}) {
  return (
    !disabledLinks.includes(AppPageLink.COMPANY_PAGE) && status !== 'APPROVED'
  );
}
